import { bithidePartnerName } from 'shared/settings';
import BaseApi from '../BaseApi';
import { BithidePaymentApiConverter } from './BithidePaymentApiConverter';
import { parseCookies } from 'shared/utils/parseCookies';

class BithidePaymentApi extends BaseApi {
  constructor(baseUrl) {
    super(baseUrl);
    this.baseUrl = `${baseUrl}/bithide`;
    this.converter = new BithidePaymentApiConverter();
  }

  getCurrencyRate = () =>
    this.sendQuery(
      this.queryTypes.GET,
      `${this.baseUrl}/currency_rate?from_currency=USDT-TRC20&to_currency=TND`,
      null,
      this.converter.convertCurrencyRate,
    );
    
  depositInit = ({
    fromCurrency,
    toCurrency,
    fromCurrencyAmount,
  }) => this.sendQuery(
    this.queryTypes.POST,
    `${this.baseUrl}/deposit/init`,
    {
      from_currency: fromCurrency,
      to_currency: toCurrency,
      from_currency_amount: fromCurrencyAmount,
    },
    {
      headers: {
        'x-partner-name': bithidePartnerName,
        'x-partner-authorization': parseCookies(),
      }
    },
    this.converter.convertDepositInitData,
  );

  getDepositInfo = ({ depositId }) => this.sendQuery(
    this.queryTypes.GET,
    `${this.baseUrl}/deposit/${depositId}`,
    null,
    {
      headers: {
        'x-partner-name': bithidePartnerName,
        'x-partner-authorization': parseCookies(),
      }
    },
    this.converter.convertDepositInfo,
  );

  getDepositHistory = requestData => this.sendQuery(
    this.queryTypes.GET,
    `${this.baseUrl}/deposits`,
    requestData,
    {
      headers: {
        'x-partner-name': bithidePartnerName,
        'x-partner-authorization': parseCookies(),
      }
    },
    this.converter.convertDepositHistory,
  );
}

export default BithidePaymentApi;
